import React, { useState, useEffect } from "react";
import s from "./PredistributionDetail.module.css";

//assets
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { dateFormats } from "src/helpers/convertDate";

//Material
import {
  Grid,
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Avatar,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useTranslationException from "src/helpers/exceptions";
import masiveDistributionServices from "src/api/delivery/masiveDistribution";

function PreDistributionDetail({ data, setData }) {    
    const [loading, setLoading] = useState(false);
    const organization = useSelector((state) => state.gamma.activeOrganization);
    const { textColor } = useSelector((state) => state.local);
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const showExpetion = useTranslationException(t, i18n);
    const [items, setItems] = useState();
    const dates = dateFormats();

    const cellStyles = {
      fontFamily: "Roboto, sans-serif",
      fontSize: ".9rem",
      fontWeight: "400",
      borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    };

     useEffect(() => {
      setLoading(true);
      masiveDistributionServices.getTelekinoItems(data.id)
      .then((res) => {
        setItems(res.content);
      })
      .then(()=> setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        )}
      )

      }, []);
  
    return (
      <Grid container className={s.container}>
        <Grid item xs={11} className={s.titleContainer}>
          <ArrowBackIcon
            sx={{ color: "primary.main", fontSize: "4vh" }}
            onClick={() => {
              setData({
                ...data,
                active: false,
              });
            }}
            className={s.arrow}
          />
          <div className={s.title}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                color: textColor,
                fontSize: "4vh",
              }}
              className={s.chip}
            >
              {t("Pre-DistributionTelekino")}
            </Box>
          </div>
        </Grid>

        {loading ? (
              <Grid item xs={11} className={s.loader}>
                <CircularProgress size={"3rem"} />
              </Grid>
            ) : items?.length ? (
            <Grid item container xs={11} className={s.data}>
              {/* <Accordion
                defaultExpanded={true}
                className={s.accordion}
                sx={{ backgroundColor: "transparent", border: 0, boxShadow: "none" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
                  sx={{ backgroundColor: "primary.main", borderRadius: "0 0 0 0" }}
                >
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 300,
                      fontFamily: "Roboto, sans-serif",
                      color: textColor,
                    }}
                  >
                    {t("moreInformation")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={s.dataContainer}> */}
                  <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                  <TableHead>
                  <TableRow>
                  <TableCell
                   sx={{
                   backgroundColor: "primary.main",
                   color: textColor,
                   fontSize: ".9rem",
                   fontWeight: 500,
                   fontFamily: "Roboto, sans-Serif",
                   }}
                   >{t("drawNumber")}
                  </TableCell>
                  <TableCell
                   sx={{
                   backgroundColor: "primary.main",
                   color: textColor,
                   fontSize: ".9rem",
                   fontWeight: 500,
                   fontFamily: "Roboto, sans-Serif",
                   }}
                   >{t("fromCoupon")}
                  </TableCell>
                  <TableCell
                   sx={{
                   backgroundColor: "primary.main",
                   color: textColor,
                   fontSize: ".9rem",
                   fontWeight: 500,
                   fontFamily: "Roboto, sans-Serif",
                   }}
                   >{t("toCoupon")}
                  </TableCell>
                  <TableCell
                   sx={{
                   backgroundColor: "primary.main",
                   color: textColor,
                   fontSize: ".9rem",
                   fontWeight: 500,
                   fontFamily: "Roboto, sans-Serif",
                   }}
                   >{t("numberRecords")}
                  </TableCell>
                  </TableRow>  
                  </TableHead>
                  <TableBody>
                  {items.map((item, i) => { 
                return(
                  <React.Fragment key={item.id}>
                  <TableRow
                   sx={{
                   "&:hover": {
                   backgroundColor: "secondary.light",
                   },
                   }}
                   >
                   <TableCell
                   sx={{
                   ...cellStyles,
                   backgroundColor:
                   i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                   }}>
                   {data?.raffleId}
                   </TableCell>
                   <TableCell
                   sx={{
                   ...cellStyles,
                   backgroundColor:
                   i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                   }}>
                   {item?.cuponDesde}
                   </TableCell>
                   <TableCell
                   sx={{
                   ...cellStyles,
                   backgroundColor:
                   i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                   }}>
                   {item?.cuponHasta}
                   </TableCell>
                   <TableCell
                   sx={{
                   ...cellStyles,
                   backgroundColor:
                   i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                   }}>
                   {item?.cantidadDeCupones}
                   </TableCell>
                   </TableRow>
                  </React.Fragment>
                )})}
                  </TableBody>                                        
                  </Table>  
                  </TableContainer>
                  {/* <div className={s.item}>
                    <h3>CUIT</h3>
                    <p>{formatCuit(data.cuit)}</p>
                  </div>
                  <div className={s.item}>
                    <h3>{t("taxCondition")}</h3>
                    <p>{data.fiscalCondition}</p>
                  </div>
                  <div className={s.item}>
                    <h3>{t("address")}</h3>
                    <p>{data.address}</p>
                  </div>
                  <div className={s.item}>
                    <h3>{t("type")}</h3>
                    <p>{data.typeSupplier}</p>
                  </div> */}
                {/* </AccordionDetails>
              </Accordion> */}
            </Grid>) : <></> }
      </Grid>
    );
  }
  
  export default PreDistributionDetail;